import { CommandDispatcher } from "../../shared/domain/CommandDispatcher";

interface MessageHandler {
  message: string;
  show_message: boolean;
}

export class KillThreadProcess {
  constructor(
    private readonly dispatcher: CommandDispatcher,
    private readonly screen_data: { [key: string]: boolean },
    private readonly message_handler: MessageHandler,
  ) {}

  async run(thread_id: string, extra_args?: { [key: string]: any }): Promise<void> {
    const loading_key = `kill_thread_${thread_id}_loading`;
    this.screen_data[loading_key] = true;

    try {
      const args = { thread_id, ...extra_args };
      const result = await this.dispatcher.dispatch('kill.thread.process', args);
      console.log('Operation created successfully:', result);
      this.message_handler.message = `Operation created successfully for thread ${thread_id}`;
      this.message_handler.show_message = true;
    } catch (error) {
      console.error('Error creating operation:', error);
      this.message_handler.message = `Error creating operation for thread ${thread_id}: ${error.message || error}`;
      this.message_handler.show_message = true;
    } finally {
      this.screen_data[loading_key] = false;
    }
  }
}
